<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Material Session
            <v-icon right>add_circle</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-data-table
                  :headers="headers"
                  :items="materialSessionList"
                  class="elevation-1"
                  :loading="showListLoading"
                  :total-items="totalRows"
                  :rows-per-page-items="rowsPerPageItems"
                  :pagination.sync="pagination"
                  :must-sort="true"
                >
                <template slot="items" slot-scope="props">
                    <td>
                      <v-btn
                        flat
                        icon
                        color="blue lighten-2"
                        @click="onEdit(props.item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <v-icon
                        v-if="props.item.status == 'ACTIVE'"
                        medium
                        color="green"
                        >check_circle</v-icon
                      >
                      <v-icon v-else medium color="red">cancel</v-icon>
                    </td>
                    <td>{{ props.item.code }}</td>
                    <td>{{ props.item.name }}</td>
                    <td>{{ props.item.description }}</td>
                    <td>
                      {{
                        props.item.updatedDateInMilliSeconds
                          | format-ms-date-time
                      }}
                    </td>
                    <td>{{ props.item.updatedBy }}</td>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { materialSessionService } from "../../services/material-session-service";

export default {
  name: "MaterialSessionList",
  components: {},
  data: () => ({
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Manufacturing Management",
        disabled: true,
      },
      {
        text: "Material Session",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Description", align: "left", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
    },
    rowsPerPageItems: [25, 50, 100],
    materialSessionList: [],
    totalRows: 0,
  }),
  watch: {
    pagination: {
      handler() {
        this.getmaterialSessionList();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "material-sessions",
        query: this.queryParams,
      });
      this.getmaterialSessionList();
    },
    getmaterialSessionList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      materialSessionService
        .getMaterialSessionList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.materialSessionList = res.data.materialSessionList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/material-session/new");
    },
    onEdit(materialSession) {
      // go to details page
      this.$router.push("/material-session/" + materialSession.id);
    },
  },
};
</script>

